"use client";

import React, { useState } from "react";
import { Sidebar } from "./sidebar";
import { TopBar } from "./top-bar";
import { CommandPalette } from "./command-palette";
import { CompanionBot } from "./companion-bot";

interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-background text-foreground">
      {/* Sidebar Panel (Collapsible / Off-canvas drawer) */}
      <Sidebar
        isOpen={isMobileSidebarOpen}
        onClose={() => setIsMobileSidebarOpen(false)}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />

      {/* Main Panel Content Area */}
      <div className="flex flex-1 flex-col h-full overflow-hidden">
        {/* Top Header Actions */}
        <TopBar onOpenMobileSidebar={() => setIsMobileSidebarOpen(true)} />

        {/* Scrollable Workspace Node */}
        <main className="flex-1 overflow-hidden relative bg-background">
          {children}
        </main>
      </div>

      {/* Global Command Palette (Ctrl+K) */}
      <CommandPalette />

      {/* Floating AI Companion Widget */}
      <CompanionBot />
    </div>
  );
}
